// spのfixedナビ 途中から出現
(function() {
	const fixedNav = document.querySelector('.l-fixed__nav');
	const floatingNews = document.querySelector('.l-floating__news');
	if (fixedNav) {
		window.addEventListener('scroll', () => {
			if (window.scrollY > 850) {
				fixedNav.classList.add('is-show');
				// 重要なお知らせがある場合は、fixedナビの出現に合わせて位置を移動
				if (floatingNews) {
					floatingNews.classList.add('is-move');
				}
			} else {
				fixedNav.classList.remove('is-show');
				if (floatingNews) {
					floatingNews.classList.remove('is-move');
				}
			}
		});
	}
}());
